export const HOME = 'Home';
export const AWAY = 'Away';